class CategoryVideos extends HTMLElement {
  constructor() {
    super();
    this.splide = null;
    this.isMuted = false;
    this.activeCollectionUrl = null;
  }

  connectedCallback() {
    this.categoriesList = this.querySelectorAll('.category-item-container');
    this.popupWrapper = this.querySelector('.category-videos-popup-wrapper');
    this.popupCloseButton = this.querySelector('.popup-close-button');
    this.videoContainer = this.querySelector('.category-videos-container');
    this.videoData = JSON.parse(
      this.querySelector('.category-videos-data')?.textContent || '{}'
    );
    this.globalMuteBtn = this.querySelector('.video-mute-btn');
    this.globalShareBtn = this.querySelector('.video-share-btn');

    this.navSvg = '<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 64 64" width="48px" height="48px"><path d="M 40 10 C 38.896 10 38 10.896 38 12 C 38 13.104 38.896 14 40 14 L 47.171875 14 L 30.585938 30.585938 C 29.804938 31.366938 29.804938 32.633063 30.585938 33.414062 C 30.976938 33.805063 31.488 34 32 34 C 32.512 34 33.023063 33.805062 33.414062 33.414062 L 50 16.828125 L 50 24 C 50 25.104 50.896 26 52 26 C 53.104 26 54 25.104 54 24 L 54 12 C 54 10.896 53.104 10 52 10 L 40 10 z M 18 12 C 14.691 12 12 14.691 12 18 L 12 46 C 12 49.309 14.691 52 18 52 L 46 52 C 49.309 52 52 49.309 52 46 L 52 34 C 52 32.896 51.104 32 50 32 C 48.896 32 48 32.896 48 34 L 48 46 C 48 47.103 47.103 48 46 48 L 18 48 C 16.897 48 16 47.103 16 46 L 16 18 C 16 16.897 16.897 16 18 16 L 30 16 C 31.104 16 32 15.104 32 14 C 32 12.896 31.104 12 30 12 L 18 12 z" fill="#ffffff"/></svg>';
    this.soundSvg = '<svg width="64px" height="64px" viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#ffffff" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"/><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/><g id="SVGRepo_iconCarrier"> <title>sound-loud-filled</title> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="icon" fill="#ffffff" transform="translate(42.666667, 85.333333)"> <path d="M361.299413,341.610667 L328.014293,314.98176 C402.206933,233.906133 402.206933,109.96608 328.013013,28.8906667 L361.298133,2.26304 C447.910187,98.97536 447.908907,244.898347 361.299413,341.610667 Z M276.912853,69.77216 L243.588693,96.4309333 C283.38432,138.998613 283.38304,204.87488 243.589973,247.44256 L276.914133,274.101333 C329.118507,215.880107 329.118507,127.992107 276.912853,69.77216 Z M191.749973,1.42108547e-14 L80.8957867,87.2292267 L7.10542736e-15,87.2292267 L7.10542736e-15,257.895893 L81.0208,257.895893 L191.749973,343.35424 L191.749973,1.42108547e-14 L191.749973,1.42108547e-14 Z" id="Shape"> </path> </g> </g> </g></svg>';
    this.shareSvg = '<svg fill="#ffffff" width="64px" height="64px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"/><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/><g id="SVGRepo_iconCarrier"> <path d="M27 22c-1.646 0-3.103 0.8-4.013 2.028l-13.168-6.71c0.114-0.421 0.181-0.86 0.181-1.317 0-0.572-0.101-1.119-0.277-1.63l13.242-6.426c0.909 1.244 2.375 2.056 4.035 2.056 2.762 0 5-2.239 5-5s-2.238-5-5-5-5 2.239-5 5c0 0.388 0.049 0.764 0.133 1.127l-13.432 6.518c-0.915-1.009-2.231-1.646-3.7-1.646-2.761 0-5 2.239-5 5s2.239 5 5 5c1.59 0 3.004-0.744 3.92-1.902l13.222 6.739c-0.090 0.374-0.142 0.762-0.142 1.163 0 2.761 2.238 5 5 5s5-2.239 5-5-2.238-5-5-5zM27 2c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zM5 19c-1.657 0-3-1.343-3-3s1.343-3 3-3c1.657 0 3 1.344 3 3s-1.343 3-3 3zM27 30c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z"/> </g></svg>';
    this.mutedSoundSvg = `<svg width="64px" height="64px" viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#ffffff" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"/><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/><g id="SVGRepo_iconCarrier"> <title>sound-off</title> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="icon" fill="#ffffff" transform="translate(42.666667, 59.581722)"> <path d="M47.0849493,-1.42108547e-14 L409.751616,362.666662 L379.581717,392.836561 L191.749,205.003 L191.749973,369.105851 L81.0208,283.647505 L7.10542736e-15,283.647505 L7.10542736e-15,112.980838 L80.8957867,112.980838 L91.433,104.688 L16.9150553,30.169894 L47.0849493,-1.42108547e-14 Z M361.298133,28.0146513 C429.03793,103.653926 443.79725,209.394854 405.578543,298.152074 L372.628731,265.200172 C396.498116,194.196781 381.626371,113.22828 328.013013,54.642278 L361.298133,28.0146513 Z M121.824,135.078 L95.6874667,155.647505 L42.6666667,155.647505 L42.6666667,240.980838 L95.5624533,240.980838 L149.083307,282.272358 L149.083,162.337 L121.824,135.078 Z M276.912853,95.5237713 C305.539112,127.447886 318.468552,168.292377 315.701384,208.274722 L266.463468,159.037386 C261.494642,145.732631 253.869746,133.179747 243.588693,122.182545 L243.588693,122.182545 Z M191.749973,25.7516113 L191.749,84.325 L158.969,51.545 L191.749973,25.7516113 Z" id="Combined-Shape"> </path> </g> </g> </g></svg>`;

    this.bindEvents();
  }

  bindEvents() {
    this.categoriesList.forEach(category => {
      category.addEventListener('click', () => {
        const index = category.dataset.blockIndex;
        this.openPopup(index);
      });
    });

    this.popupCloseButton?.addEventListener('click', e => {
      e.stopPropagation();
      this.closePopup();
    });

    this.popupWrapper?.addEventListener('click', e => {
      if (e.target === this.popupWrapper) {
        this.closePopup();
      }
    });

    // 🔊 GLOBAL MUTE TOGGLE
    this.globalMuteBtn?.addEventListener('click', e => {
      e.stopPropagation();
      this.isMuted = !this.isMuted;

      const videos = this.querySelectorAll('video');
      // videos.forEach(video => video.muted = this.isMuted);
      videos.forEach(video => {
        video.muted = this.isMuted;
        video.volume = this.isMuted ? 0 : 1;
      });

      this.syncActiveVideoMute();

      this.globalMuteBtn.innerHTML = this.isMuted
        ? this.mutedSoundSvg
        : this.soundSvg;
    });

    // 🔗 GLOBAL SHARE
    this.globalShareBtn?.addEventListener('click', e => {
      e.stopPropagation();
      if (!this.activeCollectionUrl) return;

      if (navigator.share) {
        navigator.share({
          url: this.activeCollectionUrl
        });
      }
    });

  }

  openPopup(blockIndex) {
    const videos = this.videoData[blockIndex];
    if (!videos || !videos.length) return;

    this.renderVideos(videos);

    this.popupWrapper.classList.remove('hidden');
    setTimeout(() => this.updateContainerWidth(), 50);
  }

  closePopup() {
    this.popupWrapper.classList.add('hidden');
    this.destroySplide();
    this.videoContainer.innerHTML = '';
  }

  renderVideos(videos) {
    this.videoContainer.innerHTML = `
      <div class="splide category-video-splide">
        <div class="splide__track">
          <ul class="splide__list">
            ${videos.map((v, i) => `
              <li class="splide__slide" data-collection-url="${v.collection_url}" data-product-url="${v.products?.length === 1 ? v.products[0].url : ''}">
                <div class="video-wrapper" style="aspect-ratio:${v.video_width / v.video_height};" data-index="${i}">
                  <div class="video-progress">
                    <span class="video-progress-fill"></span>
                  </div>
                  <video
                    src="${v.video}"
                    poster="${v.poster}"
                    playsinline
                    muted
                    preload="metadata"
                    autoplay
                  ></video>

                  ${v.products?.length ? `
                    <div class="video-products-strip">
                      <div class="video-products-splide splide">
                        <div class="splide__track">
                          <ul class="splide__list">
                            ${v.products.map(p => `
                              <li class="splide__slide">
                                <a href="${p.url}" class="video-product-bar">
                                  <div class="video-product-info">
                                    <img src="${p.image}" class="video-product-img" alt="${p.title}">
                                    <div class="video-product-title-price-wrapper">
                                      <span class="video-product-title">${p.title}</span>
                                      <div class="video-product-price-wrapper">
                                        <div>
                                          <span class="currency-symbol">₹</span>
                                          <ins class="video-product-price">${Math.ceil(p.price)}</ins>
                                        </div>
                                        <div>
                                          <span class="currency-symbol">₹</span>
                                          <del class="video-product-compare-price">${Math.ceil(p.compare_price)}</del>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </li>
                            `).join('')}
                          </ul>
                        </div>
                      </div>
                    </div>
                  ` : ''}
                </div>
              </li>
            `).join('')}
          </ul>
        </div>
      </div>
    `;

    this.initSplide();
  }


  initSplide() {
    this.destroySplide();

    this.splide = new Splide('.category-video-splide', {
      perPage: 1,
      gap: '0px',
      pagination: true,
      arrows: false,
      drag: true,
      flickPower: 300,
      autoWidth: true,
      noDrag: '.video-products-track, .video-product-bar, .video-product-info, .video-product-img, .video-product-title, .video-product-price-wrapper, .currency-symbol, .video-product-price, .video-product-compare-price',
      breakpoints: {
        768: {
          autoWidth: false
        }
      }
    });

    this.splide.on('mounted move', () => {
      const wrappers = this.videoContainer.querySelectorAll('.video-wrapper');
      this.handleVideoPlayback();
      this.updateContainerWidth();
    });

    this.splide.mount();

    // Initialize inner Splides for product sliders
    // this.videoContainer.querySelectorAll('.video-products-splide').forEach(innerSplideEl => {
    //   const innerSplide = new Splide(innerSplideEl, {
    //     perPage: 1,
    //     gap: '10px',
    //     pagination: false,
    //     arrows: false,
    //     drag: true,
    //     padding: { right: '8%' },
    //   });
      
    //   innerSplide.mount();
    // });

    this.videoContainer.querySelectorAll('.video-products-splide').forEach(innerSplideEl => {
      const slidesCount = innerSplideEl.querySelectorAll('.splide__slide').length;

      const isSingle = slidesCount <= 1;

      const innerSplide = new Splide(innerSplideEl, {
        perPage: 1,
        gap: isSingle ? '0px' : '10px',
        pagination: false,
        arrows: false,
        drag: !isSingle, // optional: disable drag if only one
        padding: isSingle ? { right: '0px' } : { right: '8%' },
      });

      innerSplide.mount();
    });

  }
  
  handleVideoPlayback() {
    const slides = this.querySelectorAll(
      '.category-video-splide > .splide__track > .splide__list > .splide__slide'
    );

    const paginationButtons = this.videoContainer.querySelectorAll(
      '.category-video-splide .splide__pagination button'
    );

    slides.forEach((slide, index) => {
      const video = slide.querySelector('video');
      const progress = slide.querySelector('.video-progress-fill');
      const wrapper = slide.querySelector('.video-wrapper');

      if (!video || !progress || !wrapper) return;

      /* -----------------------------
        INACTIVE SLIDES
      ----------------------------- */
      if (index !== this.splide.index) {
        video.pause();
        video.currentTime = 0;
        // video.muted = true;
        video.muted = this.isMuted;
        video.volume = this.isMuted ? 0 : 1;
        progress.style.width = '0%';
        return;
      }

      /* -----------------------------
        ACTIVE SLIDE
      ----------------------------- */
      const productUrl = slide.dataset.productUrl;
      const collectionUrl = slide.dataset.collectionUrl;

      // If single product → use product URL, else collection
      this.activeCollectionUrl = productUrl || collectionUrl || null;
      video.muted = this.isMuted;
      video.volume = this.isMuted ? 0 : 1;
      video.play().catch(() => { console.error("Autoplay failed for video")});
      const videoEl = slide.querySelector('video');
      videoEl.addEventListener('loadedmetadata', () => {
        this.updateContainerWidth();
      });


      /* -----------------------------
        PAGINATION PROGRESS
      ----------------------------- */
      paginationButtons.forEach((btn, btnIndex) => {
        if (btnIndex < index) btn.style.setProperty('--progress', '100%');
        else if (btnIndex > index) btn.style.setProperty('--progress', '0%');
      });

      video.ontimeupdate = () => {
        if (!video.duration) return;
        const percent = (video.currentTime / video.duration) * 100;
        progress.style.width = `${percent}%`;

        const activePagination = this.querySelector(
          '.category-video-splide .splide__pagination button.is-active'
        );
        activePagination?.style.setProperty('--progress', `${percent}%`);
      };

      video.onended = () => {
        progress.style.width = '100%';
        if (this.splide.index < slides.length - 1) this.splide.go('>');
      };

      /* -----------------------------
        TAP / CLICK LEFT-RIGHT NAVIGATION
      ----------------------------- */
      wrapper.onclick = e => {
        const rect = wrapper.getBoundingClientRect();
        const x = e.clientX - rect.left; // Click position relative to wrapper
        const half = rect.width / 2;

        if (x > half) {
          // Clicked right → next video
          if (this.splide.index < slides.length - 1) this.splide.go('>');
        } else {
          // Clicked left → previous video
          if (this.splide.index > 0) this.splide.go('<');
        }
      };
    });
  }

  syncActiveVideoMute() {
    if (!this.splide) return;

    const activeSlide = this.querySelector(
      `.category-video-splide .splide__slide.is-active`
    );

    const video = activeSlide?.querySelector('video');
    if (!video) return;

    video.muted = this.isMuted;
    video.volume = this.isMuted ? 0 : 1;

    // Required for iOS / Safari to re-apply audio
    if (!this.isMuted) {
      video.play().catch(() => {});
    }
  }

  updateContainerWidth() {
    requestAnimationFrame(() => {
      const activeSlide = this.querySelector(
        '.category-video-splide .splide__slide.is-active .video-wrapper'
      );

      if (!activeSlide) return;

      const rect = activeSlide.getBoundingClientRect();

      if (rect.width > 0) {
        this.videoContainer.style.width = `${Math.ceil(rect.width)}px`;
      }
    });
  }


  destroySplide() {
    if (this.splide) {
      this.splide.destroy();
      this.splide = null;
    }
  }
}

customElements.define('category-videos', CategoryVideos);